var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-overlay identify-content", class: _vm.position },
    [
      _vm.steep == 1
        ? _c("div", { staticClass: "steep1" }, [
            _vm.personsSelectIsMaxed
              ? _c("p", [
                  _vm._v(
                    _vm._s(_vm.$t("dash.post-creator.overlay.max-persons"))
                  ),
                ])
              : _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "dash.post-creator.overlay.select-person-instruction"
                      )
                    )
                  ),
                ]),
            _vm.personsSelect.length
              ? _c("div", { staticClass: "content" }, [
                  _c(
                    "div",
                    { staticClass: "list-item hide-scrollbar" },
                    [
                      false ? _c("span", { staticClass: "loader" }) : _vm._e(),
                      _vm._l(_vm.personsSelect, function (person) {
                        return _c(
                          "div",
                          {
                            key: person.id || person.name,
                            staticClass: "item",
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: person.image
                                  ? person.image
                                  : "img/avatar.jpg",
                                alt: "",
                              },
                            }),
                            _c("div", { staticClass: "info" }, [
                              _c("p", { staticClass: "username" }, [
                                _vm._v(
                                  _vm._s(person.id ? person.id : person.name)
                                ),
                              ]),
                              _c("p", { staticClass: "name" }, [
                                _vm._v(_vm._s(person.name)),
                              ]),
                            ]),
                            _c("i", {
                              staticClass: "fa-regular fa-xmark",
                              on: {
                                click: function ($event) {
                                  return _vm.removePerson(person.id)
                                },
                              },
                            }),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                ])
              : _vm._e(),
          ])
        : _vm.steep == 2
        ? _c("div", { staticClass: "steep2" }, [
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "input" }, [
                _c("i", { staticClass: "fa-regular fa-magnifying-glass" }),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.textSearch,
                      expression: "textSearch",
                    },
                  ],
                  attrs: {
                    placeholder: _vm.$t(
                      "dash.post-creator.overlay.search-person"
                    ),
                  },
                  domProps: { value: _vm.textSearch },
                  on: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.sendSearchPerson.apply(null, arguments)
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.textSearch = $event.target.value
                    },
                  },
                }),
              ]),
              _c(
                "div",
                { staticClass: "list-item hide-scrollbar" },
                [
                  _vm.stateLoader
                    ? _c("span", { staticClass: "loader" })
                    : _vm.listPersonsAvailable.length
                    ? _vm._l(_vm.listPersonsAvailable, function (person) {
                        return _c(
                          "div",
                          {
                            key: person.id || person.name,
                            staticClass: "item",
                            on: {
                              click: function ($event) {
                                return _vm.selectPerson(person)
                              },
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: person.image
                                  ? person.image
                                  : "img/avatar.jpg",
                                alt: "",
                              },
                            }),
                            _c("div", { staticClass: "info" }, [
                              _c("p", { staticClass: "username" }, [
                                _vm._v(
                                  _vm._s(person.id ? person.id : person.name)
                                ),
                              ]),
                              _c("p", { staticClass: "name" }, [
                                _vm._v(_vm._s(person.name)),
                              ]),
                            ]),
                          ]
                        )
                      })
                    : _vm.textSearch
                    ? _c("p", { staticClass: "no-result" }, [
                        _vm._v(
                          _vm._s(_vm.$t("dash.post-creator.overlay.no-person"))
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]),
          ])
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "btn-secondary",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("dash.button.close")))]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }